import { render, staticRenderFns } from "./GridFileItem.vue?vue&type=template&id=3cbf4ed5&scoped=true&"
import script from "./GridFileItem.vue?vue&type=script&lang=ts&"
export * from "./GridFileItem.vue?vue&type=script&lang=ts&"
import style0 from "./GridFileItem.vue?vue&type=style&index=0&id=3cbf4ed5&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbf4ed5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VImg,VProgressCircular,VRow})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
